<template>
  <div class="parts-container">
    <!-- 查询区域 -->
    <div class="query-section">
      <queryc @change="cascadeQeuryChange"></queryc>
    </div>

    <!-- 选项区域 -->
    <div class="options-section">
      <el-checkbox-group v-model="selectCheckbox" size="small">
        <el-checkbox label="1">
          <i class="el-icon-document"></i> 教材
        </el-checkbox>
        <el-checkbox label="2">
          <i class="el-icon-picture"></i> 缩略图
        </el-checkbox>
      </el-checkbox-group>
    </div>

    <!-- Tab内容区域 -->
    <div class="tabs-section">
      <el-tabs v-model="selectTab" :tab-position="tabPosition" @tab-click="tabClick" class="custom-tabs">
        <el-tab-pane v-for="(item, index) in panelList" :key="index" :name="item.name" class="file-panel">
          <template slot="label">
            <div class="tab-label">
              <i :class="item.icon"></i>
              <span class="label-text">{{ item.label }}</span>
              <el-badge v-if="item.count > 0" :value="item.count" :max="99" class="tab-badge" type="primary">
              </el-badge>
            </div>
          </template>

          <!-- 视频/图片上传组件 -->
          <myvideo v-if="item.name === selectTab && item.name !== '7'" :productList="productList"
            :productCode="productCode" :height="tableHeight" :selectCheckbox="selectCheckbox">
          </myvideo>

          <!-- 指读训练组件 -->
          <postion v-if="item.name === selectTab && item.name === '7'" :productList="productList"
            :productCode="productCode" :panelHeight="tableHeight" :selectCheckbox="selectCheckbox">
          </postion>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Enumerable from 'linq'
import api from '@/utils/api'
import myVideo from '@/components/bg/Video'
import postion from '@/components/bg/PhotoEdit'
import query from '@/components/common/cascadeQeury'

export default {
  name: 'Parts',
  components: {
    'myvideo': myVideo,
    'postion': postion,
    'queryc': query
  },
  data () {
    return {
      video: '',
      jieimgurl: '',
      selectTab: '1',
      tabPosition: 'left',
      tableHeight: '',
      selectCheckbox: ['1', '2'],
      loading: false,
      fileList: [],
      selectSeries: '1',
      selectLevels: '1',
      selectUnits: '1',
      allProducts: [],
      productList: [],
      panelList: [],
      series: [{ label: '168系列', value: 1 }, { label: '128系列', value: 2 }, { label: '一对一系列', value: 0 }],
      levels: [],
      units: [],
      productCode: ''
    }
  },
  created () {
    this.tableHeight = (window.innerHeight - 230)
  },
  mounted () {
    this.getTabLabels()
  },
  methods: {
    getProducts () {
      if (this.selectSeries === '' || this.selectLevels === '' || this.selectUnits === '') {
        return
      }
      this.loading = true
      this.$axios.post(api.getProductParts, {
        PageIndex: 1,
        Series: this.selectSeries,
        Level: this.selectLevels,
        ProductUnit: this.selectUnits,
        PageSize: 1000
      })
        .then(res => {
          this.allProducts.splice(0, this.allProducts.length)
          this.allProducts = res.data.result.items
          this.getProductCode()
          this.productList.splice(0, this.productList.length)
          console.log('this.selectTab', this.selectTab)
          this.allProducts.forEach(item => {
            if (item.courseType.toString() === this.selectTab) {
              this.productList.push(item)
            }
          })
          this.productList = Enumerable.from(this.productList).orderBy(o => o.productCode).toArray()
          this.getTabLabels()
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    getTabLabels () {
      this.panelList = [
        { name: '1', icon: 'el-icon-s-platform', label: '课件', count: Enumerable.from(this.allProducts).count(c => c.courseType === 1) },
        { name: '2', icon: 'el-icon-video-camera', label: '视频', count: Enumerable.from(this.allProducts).count(c => c.courseType === 2) },
        { name: '3', icon: 'el-icon-picture-outline', label: '图片', count: Enumerable.from(this.allProducts).count(c => c.courseType === 3) },
        { name: '4', icon: 'el-icon-microphone', label: 'Read Aloud', count: Enumerable.from(this.allProducts).count(c => c.courseType === 4) },
        { name: '5', icon: 'el-icon-headset', label: '听力部分', count: Enumerable.from(this.allProducts).count(c => c.courseType === 5) },
        { name: '6', icon: 'el-icon-s-promotion', label: '扩展资源', count: Enumerable.from(this.allProducts).count(c => c.courseType === 6) },
        { name: '7', icon: 'el-icon-thumb', label: '指读训练', count: Enumerable.from(this.allProducts).count(c => c.courseType === 7) },
        { name: '8', icon: 'el-icon-notebook-2', label: 'Workbook听力', count: Enumerable.from(this.allProducts).count(c => c.courseType === 8) }
      ]
    },
    tabClick (tab) {
      this.selectTab = tab.name
      this.productList.splice(0, this.productList.length)
      this.getProductCode()
      this.allProducts.forEach(item => {
        if (item.courseType.toString() === this.selectTab) {
          this.productList.push(item)
        }
      })
      this.productList = Enumerable.from(this.productList)
        .orderBy(o => o.productCode)
        .toArray()
    },
    getProductCode () {
      this.productCode = this.selectSeries + '-' + this.selectLevels + '-' + this.selectUnits + '-' + this.selectTab
    },
    handleChange (file, fileList) {
      this.fileList = fileList
      const URL = window.URL || window.webkitURL
      this.video = URL.createObjectURL(file.raw)
      this.videolist = fileList.length
    },
    unitsChange (obj) {
      this.selectUnits = obj
      this.getProducts()
    },
    cascadeQeuryChange (query) {
      this.pageIndex = 1
      this.selectSeries = query.selectSeries
      this.selectLevels = query.selectLevels
      this.selectUnits = query.selectUnits
      this.getProducts()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';

.parts-container {
  padding: $spacing-lg;
  background: var(--bg-base);
  min-height: calc(100vh - 120px);
}

.query-section {
  margin-bottom: $spacing-lg;
}

.options-section {
  background: var(--bg-white);
  border-radius: $border-radius-base;
  padding: $spacing-md $spacing-lg;
  margin-bottom: $spacing-lg;
  box-shadow: var(--shadow-base);

  .el-checkbox-group {
    .el-checkbox {
      margin-right: $spacing-lg;

      i {
        margin-right: 4px;
        color: $primary-color;
      }
    }
  }
}

.tabs-section {
  background: var(--bg-white);
  border-radius: $border-radius-base;
  box-shadow: var(--shadow-base);
  overflow: hidden;

  .custom-tabs {
    ::v-deep .el-tabs__header {
      background: var(--gradient-header);
      margin: 0;
    }

    ::v-deep .el-tabs__nav-wrap {
      padding: $spacing-md 0;
    }

    ::v-deep .el-tabs__item {
      height: auto;
      line-height: normal;
      padding: $spacing-md $spacing-lg;
      margin: 4px 0;
      border-radius: 0 $border-radius-base $border-radius-base 0;
      transition: $transition-base;

      &:hover {
        background: $primary-lighter;
        color: $primary-color;
      }

      &.is-active {
        background: linear-gradient(135deg, $primary-color, $primary-light);
        color: #fff;

        .tab-label {
          i {
            color: #fff;
          }

          .label-text {
            color: #fff;
          }
        }

        ::v-deep .el-badge__content {
          background: #fff;
          color: $primary-color;
        }
      }
    }

    .tab-label {
      display: flex;
      align-items: center;
      gap: 8px;

      i {
        font-size: $font-size-lg;
        color: $text-secondary;
        transition: $transition-base;
      }

      .label-text {
        font-size: $font-size-base;
        color: var(--text-regular);
        transition: $transition-base;
      }

      .tab-badge {
        margin-left: 4px;

        ::v-deep .el-badge__content {
          height: 16px;
          line-height: 16px;
          padding: 0 6px;
          font-size: $font-size-xs;
        }
      }
    }

    ::v-deep .el-tabs__content {
      padding: $spacing-lg;
    }

    .file-panel {
      height: 100%;
      overflow-y: auto;
    }
  }
}

// 响应式适配
@media (max-width: $screen-md) {
  .parts-container {
    padding: $spacing-md;
  }

  .tabs-section {
    .custom-tabs {
      ::v-deep .el-tabs__header {
        width: 100% !important;
      }

      ::v-deep .el-tabs__nav-wrap {
        padding: 0;
      }

      ::v-deep .el-tabs__item {
        border-radius: $border-radius-base $border-radius-base 0 0;
        margin: 0 4px;
        padding: $spacing-sm $spacing-md;
      }

      .tab-label {
        flex-direction: column;
        gap: 4px;

        i {
          font-size: $font-size-md;
        }

        .label-text {
          font-size: $font-size-xs;
        }
      }
    }
  }
}

@media (max-width: $screen-sm) {
  .options-section {
    .el-checkbox-group {
      display: flex;
      flex-direction: column;
      gap: $spacing-sm;

      .el-checkbox {
        margin-right: 0;
      }
    }
  }

  .tabs-section {
    .custom-tabs {
      .tab-label {
        .label-text {
          display: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bg/Parts.vue